import React from "react";
import ExperienceBlockquote from "../../common/experienceBlockQuote";
import Progressbar from "../../common/progressbar";

const Experience = () => {
  let skillsBar = [
    { title: "REACT JS", value: 75 },
    { title: "NODE JS", value: 55 },
    { title: "JAVASCRIPT", value: 80 },
    { title: "CSS3", value: 65 },
    { title: "HTML5", value: 80 },
    { title: "NPM", value: 60 },
    { title: "GITHUB", value: 50 },
    { title: "COREL DRAW", value: 90 },
    { title: "ADOBE PHOTOSHOP", value: 80 },
    { title: "ADOBE PREMIERE PRO", value: 65 },
    { title: "ADOBE AFTER EFFECTS", value: 50 },
    { title: "ADOBE ILLUSTRATOR", value: 40 },
  ];
  let experienceQuote = [
    {
      title: "Graphic Designer",
      duration: "May, 2016 - Present (4 Year, 8 Month)",
      description: [
        "Graphic designer responsible for daily graphic design content.",
        "Designed both eCommerce and non-eCommerce creative website layouts and content for better user experience and conversions.",
        "Developed 500+ graphics, layouts (banners, posters, event themes, cards), and 50+ logos for local shops in brand development.",
      ],
    },
    {
      title: "JavaScript/React developer",
      duration: "Feb 2020 - Present (11 Month)",
      description: [
        "Build and deploy fast and interactive React apps with confidence.",
        "With clean & maintainable code, uses modern JavaScript(ES6) features",
        "Consistently receive high user experience scores for all web development projects, including a 55% increase for Inspire Code & Graphic",
      ],
    },
    {
      title: "Front-End UI developer",
      duration: "June 2018 - Present (2 Year , 8 Month)",
      description: [
        "Built to over 5 web apps for college clubs, Increased their popularity by 60%.",
        "Contributed to 10+ web app for a 33% increase in sales, developed for a local charity.",
        "Increased 50% UI/UX experience through Graphic Design skills.",
      ],
    },
  ];
  return (
    <div className="container-fluid">
      <div className="container py-4 pt-4">
        <section id="skills">
          <div className="row pt-5">
            <div className="col-lg-6 col-md-12">
              <div className="d-flex justify-content-start">
                <h4 className="text-center text-uppercase mb-5 pb-3 mt-4">
                  My
                  <strong> experience</strong>
                </h4>
              </div>
              {experienceQuote.map((experience, index) => (
                <ExperienceBlockquote
                  key={experience.title + index}
                  title={experience.title}
                  description={experience.description}
                  duration={experience.duration}
                ></ExperienceBlockquote>
              ))}
            </div>

            <div className="col-lg-5 offset-lg-1 col-md-12">
              <div className="d-flex justify-content-start">
                <h4 className="text-center text-uppercase mb-5 pb-3 mt-4">
                  Technologies
                  <strong> & Skills</strong>
                </h4>
              </div>

              {skillsBar.map((skill, index) => (
                <Progressbar
                  key={skill.title + index}
                  title={skill.title}
                  value={skill.value}
                ></Progressbar>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Experience;
